import { useConfigStore } from "@/stores/config";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";

export default function getFeaturesRailroadData(detail, structure) {
  const configStore = useConfigStore();
  return {
    table: {
      headerRows: 0,
      widths: ["24%", "26%", "26%", "*"],
      body: [
        [
          { text: "F.02 On/Under: ", bold: true },
          {
            text: configStore.getReferenceValue(REFERENCE_TABLE.ON_UNDER, detail?.onUnder),
          },
          { text: "F.03 Feature Type: ", bold: true },
          {
            text: configStore.getReferenceValue(REFERENCE_TABLE.FEATURE_TYPE, detail?.featureType),
          },
        ],
        [
          { text: "RD.02 RR Name: ", bold: true },
          {
            text: configStore.getReferenceValue(REFERENCE_TABLE.RAILROAD_NAME, detail?.rrName),
          },
          { text: "SC.05 Min Lat Under (R): ", bold: true },
          {
            text:
              structure?.structureBridge?.hclrUrt + " ft",
          },
        ],
        [
          { text: "RD.03 Service Status: ", bold: true },
          {
            text: configStore.getReferenceValue(REFERENCE_TABLE.SERVICE_STATUS, detail?.rrServStatus),
          },
          { text: "SC.06 Min Lat Under (L): ", bold: true },
          {
            text:
              structure?.structureBridge?.hclrUlt + " ft",
          },
        ],
        [
          { text: "RD.04 RR Milepost: ", bold: true },
          {
            text: detail?.rrMilePost,
            alignment: "left",
          },
          { text: "B.RR.02 Min Over Vert (R): ", bold: true },
          {
            text:
              detail?.minOverVertClearRight + " ft",
          },
        ],
        [
          { text: "RD.05 AAR DOT Number: ", bold: true },
          {
            text: detail?.aarDotNum,
            alignment: "left",
          },
          { text: "B.RR.03 Min Over Vert (L): ", bold: true },
          {
            text:
              detail?.totHorClearRight + " ft",
          },
        ],
        [
          { text: "RD.06 # of Elec Tracks: ", bold: true },
          {
            colSpan: 3,
            text: detail?.elecTrackQty,
            alignment: "left",
          },
        ],
        [
          { text: "RD.07 Total # of Tracks: ", bold: true },
          {
            colSpan: 3,
            text: detail?.lanes,
            alignment: "left",
          },
        ],
        [
          { text: "RD.08 Span Description: ", bold: true },
          {
            colSpan: 3,
            text: detail?.spanDesc,
            alignment: "left",
          },
        ],
        [
          { text: "RD.09 Additional Operator: ", bold: true },
          {
            colSpan: 3,
            text: detail?.addOperDesc,
            alignment: "left",
          },
        ],
        [
          { text: "RD.01 Notes: ", bold: true },
          {
            colSpan: 3,
            text: detail?.notes,
            alignment: "left",
          },
        ],
      ],
    },
    layout: {
      hLineWidth: function (i, node) {
        return i === 0 || i === node.table.body.length ? 2 : 0;
      },
      vLineWidth: function (i, node) {
        return i === 0 || i === node.table.widths.length ? 1 : 0;
      },
      hLineColor: function () {
        return "black";
      },
      vLineColor: function () {
        return "gray";
      },
    },
    unbreakable: true,
    margin: [10, 0, 10, 0],
  };
}
